export const projects = [
  {
    slug: "curiosityai",
    name: "CuriosityAI",
  image: "/projectlogo/curiosityai.png",
  video: "/projectlogo/curiosityvideo.mp4",
    description: "A magical AI chatbot experience.",
    liveDemo: "https://curiosity-ai-two.vercel.app/",
    sourceCode: "https://github.com/iaadarsh23/CuriosityAI",
    status: "Operational",
    techStack: ["React", "JavaScript", "CSS", "Node.js", "GitHub", "shadcn"],
  },
  {
    slug: "bloggyfy",
    name: "Bloggyfy",
  image: "/projectlogo/bloggyfy.png",
  video: "/projectlogo/blogyfyvideo.mp4",
    description:
      "A full-featured blogging platform built with React and Java Servlet.",
    liveDemo: "https://blogyfi-psi.vercel.app/login",
    sourceCode: "https://github.com/iaadarsh23/Blogging",
    status: "Operational",
    techStack: ["Java", "Spring Boot", "React", "Tailwind"],
  },
  {
    slug: "swadsandesh",
    name: "Swad Sandesh",
    image: "/projectlogo/swadsandesh.png",
    description: "Discover delicious recipes with an AI-powered finder.",
    liveDemo: "https://swadsanket.vercel.app/",
    sourceCode: "https://github.com/iaadarsh23/SwadSandesh",
    status: "Operational",
    techStack: ["React", "JavaScript", "CSS", "Node.js", "GitHub", "shadcn"],
  },
  {
    slug: "portfolio",
    name: "Portfolio (Adarxh.me)",
    image: "/projectlogo/adarxh.png",
    description: "Modern, responsive developer portfolio.",
    liveDemo: "https://adarshtripathi.me/",
    sourceCode: "https://github.com/iaadarsh23/Adarxh.me",
    status: "Operational",
    techStack: ["Next.js", "TypeScript", "React", "shadcn"],
  },
  {
    slug: "random-password-generator",
    name: "Random Password Generator",
    image: "/projectlogo/passwordgen.png",
    description: "Generate secure passwords instantly.",
    liveDemo: "https://gett-pass.netlify.app/",
    sourceCode: "https://github.com/iaadarsh23/Random_Password_generator",
    status: "Operational",
    techStack: ["React", "JavaScript", "CSS", "Node.js", "GitHub", "shadcn"],
  },
  {
    slug: "nexuswave",
    name: "NexusWave",
    image: "/projectlogo/nexuswave.png",
    description:
      "Full stack Zoom clone app with advanced room features. In progress.",
    liveDemo: null,
    sourceCode: "https://github.com/iaadarsh23/NexusWave",
    status: "In Progress",
    techStack: ["React", "MongoDB", "Node.js", "Express"],
  },
];
